import { createContext } from 'react';
import { IToast } from './types';

export default createContext({
  notify: (val: IToast) => console.log(val),
});
